import { render } from "./OrderOutboxQueueList.vue?vue&type=template&id=4097ba20"
import script from "./OrderOutboxQueueList.vue?vue&type=script&lang=js"
export * from "./OrderOutboxQueueList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__